<template>
  <img
    class="mr-3 h-6 sm:h-9"
    :src="image || require('../../assets/images/logo.svg')"
    :alt="image + '_alt'"
    @click="go.redirectToPage('home')"
  />
</template>

<script lang="ts">
import { GoToRoute } from "@/utils/go-to.util";
import { defineComponent } from "vue";

export default defineComponent({
  name: "logo",
  computed: {
    go(): GoToRoute {
      return new GoToRoute();
    },
  },
  props: {
    image: {
      type: String,
      default: "",
    },
  },
});
</script>

